import { Component, OnInit, Input } from '@angular/core';
import { StationType } from '../../models/station';

@Component({
  selector: 'app-station-type-trans',
  templateUrl: './station-type-trans.component.html',
  styleUrls: ['./station-type-trans.component.css']
})
export class StationTypeTransComponent implements OnInit {
  @Input() stationType : StationType;
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/stations/station-type-trans/station-type-trans.component.ts